import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import { useServiceList } from '../../../hooks/useServiceList'; // Add this import

const Footer = () => {
  // Get services from Firestore
  const { services, loading: servicesLoading } = useServiceList();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <Link to="/" className="flex items-center">
              <img
                src="/winnepocketbanner.webp"
                alt="Winnepocket Landscaping"
                className="h-[80px] w-auto object-contain rounded-md"
              />
            </Link>
            </div>
            <p className="text-gray-300 mb-4">
              Professional landscaping services to transform your outdoor space into a beautiful, 
              functional environment you'll love.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li><a href="/" className="text-gray-300 hover:text-primary-400 transition-colors">Home</a></li>
              <li><a href="#services" className="text-gray-300 hover:text-primary-400 transition-colors">Services</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-primary-400 transition-colors">About</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-primary-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Services - Dynamic from Firestore */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Services</h4>
            {servicesLoading ? (
              <div className="space-y-2 text-gray-300">
                <div className="animate-pulse">
                  <div className="h-4 bg-gray-700 rounded w-3/4 mb-2"></div>
                  <div className="h-4 bg-gray-700 rounded w-2/3 mb-2"></div>
                  <div className="h-4 bg-gray-700 rounded w-4/5 mb-2"></div>
                  <div className="h-4 bg-gray-700 rounded w-1/2 mb-2"></div>
                </div>
              </div>
            ) : services && services.length > 0 ? (
              <ul className="space-y-2 text-gray-300">
                {services.slice(0, 6).map((service) => (
                  <li key={service.name}>{service.name}</li>
                ))}
                {services.length > 6 && (
                  <li className="text-primary-400 text-sm font-medium">
                    +{services.length - 6} more services
                  </li>
                )}
              </ul>
            ) : (
              // Fallback to hardcoded services if none found in Firestore
              <ul className="space-y-2 text-gray-300">
                <li>Landscape Design</li>
                <li>Lawn Maintenance</li>
                <li>Spring & Fall Cleanup</li>
                <li>Snow Removal</li>
                <li>Mulch & Materials</li>
                <li>Garden Installation</li>
              </ul>
            )}
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
            <div className="space-y-3">
              <div className="flex items-center space-x-3">
                <FaPhone className="w-4 h-4 text-primary-400" />
                <span className="text-gray-300">(603) 746-2403</span>
              </div>
              <div className="flex items-center space-x-3">
                <FaEnvelope className="w-4 h-4 text-primary-400" />
                <span className="text-gray-300">info@winnepocketlandscaping.com</span>
              </div>
              <div className="flex items-start space-x-3">
                <FaMapMarkerAlt className="w-4 h-4 text-primary-400 mt-1" />
                <span className="text-gray-300">
                  220 Burnham Intervale Rd<br />
                  Hopkinton, NH 03229
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              &copy; 2024 Winnepocket Landscaping LLC. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <a href="/" className="text-gray-400 hover:text-primary-400 text-sm transition-colors">Privacy Policy</a>
              <a href="/" className="text-gray-400 hover:text-primary-400 text-sm transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;